<template lang="">
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Start Sidebar
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
<div class="sidebar">
    <button class="sidebar-toggle-btn"><i class="las la-angle-left"></i></button>
    <div class="sidebar-wrapper">
        <ul class="sidebar-main-menu">
            <li class="sidebar-link">
                <router-link :to="{ name: 'Welcome'}">
                    <span class="title">Welcome</span>
                </router-link>
            </li>
            <li class="sidebar-link">
                <span class="sidebar-title">Web</span>
            </li>
            <li class="sidebar-link">
                <router-link :to="{ name: 'ServerSetupRequirements'}">
                    <span class="title">Server Setup Requirements</span>
                </router-link>
            </li>
            <li class="sidebar-link">
                <router-link :to="{ name: 'ServerConfiguration'}">
                    <span class="title">Server Configuration</span>
                </router-link>
            </li>
            <li class="sidebar-link">
                <router-link :to="{ name: 'AdminPanelSetup'}">
                    <span class="title">Admin Panel Setup</span>
                </router-link>
            </li>
            <li class="sidebar-link">
                <span class="sidebar-title">App</span>
            </li>
            <li class="sidebar-link">
                <router-link :to="{ name: 'FlutterEnvironmentSetup'}">
                    <span class="title">Flutter Environment Setup</span> 
                </router-link>
            </li>
            <li class="sidebar-link">
                <router-link :to="{ name: 'AppInstallation'}">
                    <span class="title">App Installation</span>
                </router-link>
            </li>
            <li class="sidebar-link">
                <router-link :to="{ name: 'DevelopmentAndTesting'}">
                    <span class="title">Development and Testing</span>
                </router-link>
            </li>
            <li class="sidebar-link">
                <router-link :to="{ name: 'AndroidAppDeployment'}">
                    <span class="title">Android App Deployment</span>
                </router-link>
            </li>
            <li class="sidebar-link">
                <router-link :to="{ name: 'iOSAppDeployment'}">
                    <span class="title">iOS App Deployment</span>
                </router-link>
            </li>
            <li class="sidebar-link">
                <span class="sidebar-title">Updates</span>
            </li>
            <li class="sidebar-link">
                <router-link :to="{ name: 'WebsiteVersionUpdate'}">
                    <span class="title">Website Version Update</span>
                </router-link>
            </li>
            <li class="sidebar-link">
                <router-link :to="{ name: 'AppVersionUpdate'}">
                    <span class="title">App Version Update</span>
                </router-link>
            </li>
        </ul>
    </div>
</div>
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    End Sidebar
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
</template>


<script>
/* eslint-disable no-undef */
export default {
  name: 'SidebarSection',
  mounted(){
    $(document).ready(function() {
        var $sidebarToggleBtn = $(".sidebar-toggle-btn"),
            $bodyWrapper = $(".body-wrapper"),
            $bodyOverlay = $(".body-overlay"),
            $sidebar = $(".sidebar");

        $sidebarToggleBtn.click(function() {
            toggleSidebar();
        });

        $bodyOverlay.click(function() {
            closeSidebar();
        });

        function toggleSidebar() {
            $sidebar.toggleClass("active");
            $bodyWrapper.toggleClass("active");
            $bodyOverlay.addClass("active");
        }

        function closeSidebar() {
            $bodyOverlay.removeClass("active");
            $sidebar.removeClass("active");
            $bodyWrapper.removeClass("active");
        }
    });

    }
};
</script>


<style lang="">
    
</style>